import { React } from 'react';
import "./ShowPage.css"
import showInfo from "./ShowInfo.json"
import ShowCard from "./ShowCard"
import Navbar from './../Navbar';
import BandsInTownWidget from './BandsInTownWidget';


function ShowPage() {

  return (
    <div className="background">
      <div className="navbar">
      <Navbar />
      </div>
      <div className="overlay">
        <div className="bandsInTownWidgetContainer">
          <BandsInTownWidget />
        </div>
      </div>
    </div>
  );
}

export default ShowPage;